const l = {
  "submenu-columns": "submenu-columns",
  "nav-block": "nav-block",
  "nav-block__item": "nav-block__item",
  "nav-block__item--active": "nav-block__item--active",
  "nav-block__item--open": "nav-block__item--open",
  "nav-block__item--link": "nav-block__item--link",
  "nav-block__title": "nav-block__title",
  "nav-block__title--active": "nav-block__title--active"
};
export {
  l as default
};
